module.exports = __webpack_public_path__ + "odstraneni-tetovaze_7_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/odstraneni-tetovaze_7_after.jpg
// module id = 963
// module chunks = 0